if (!customElements.get('dermatest-report')) {
  customElements.define('dermatest-report', class DermatestReport extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.tabs = [...this.querySelectorAll('[data-dermatest-tab]')];
      this.panels = [...this.querySelectorAll('[data-dermatest-panel]')];

      this.querySelector('[data-dermatest-open]').addEventListener('click', () => this.open());
      this.querySelector('[data-dermatest-close]').addEventListener('click', () => this.dialog.close());

      // Click on the backdrop (the dialog element itself) closes the overlay
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => document.documentElement.classList.remove('dermatest-lock'));

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(tab.dataset.dermatestTab));
        tab.addEventListener('keydown', (event) => {
          const step = { ArrowRight: 1, ArrowLeft: -1 }[event.key];
          if (!step) return;
          const next = this.tabs[(index + step + this.tabs.length) % this.tabs.length];
          next.focus();
          this.select(next.dataset.dermatestTab);
        });
      });
    }

    open() {
      this.select('result'); // Ergebnis is always the default state
      this.dialog.showModal();
      document.documentElement.classList.add('dermatest-lock');
      this.dialog.querySelector('.dermatest-dialog__body').scrollTop = 0;
    }

    select(name) {
      if (this.tabs.length === 0) return; // short version: single static panel, nothing to switch

      this.tabs.forEach((tab) => {
        const active = tab.dataset.dermatestTab === name;
        tab.setAttribute('aria-selected', active);
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.dermatestPanel !== name;
      });
    }
  });
}
